import { Capacitor } from '@capacitor/core';
import { GA_TRACKING_CODE } from '@sophocles/config';
import ReactGA from 'react-ga4';

export const initGoogleAnalytics = () => {
  if (!GA_TRACKING_CODE) {
    return;
  }
  const platform = Capacitor.getPlatform();
  const isDev = process.env.NODE_ENV === 'development';

  ReactGA.initialize(GA_TRACKING_CODE);
  ReactGA.set({ platform, debug_mode: isDev });
};

export const setUserProperties = user => {
  if (!GA_TRACKING_CODE) {
    return;
  }
  const properties = {
    platform: Capacitor.getPlatform(),
    debug_mode: process.env.NODE_ENV === 'development',
    user_id: user?.id,
    user_email: user?.email,
    user_first_name: user?.first_name,
    user_last_name: user?.last_name,
  };

  ReactGA.set(properties);
};

export const trackPageView = path => {
  if (!GA_TRACKING_CODE) {
    return;
  }
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = (eventName, eventParams = {}) => {
  if (!GA_TRACKING_CODE) {
    return;
  }
  const platform = Capacitor.getPlatform();
  ReactGA.event(eventName, { platform, ...eventParams });
};
